
export default function Why() {
    return(
        <div className="whycomp">
        <img src="https://images.unsplash.com/photo-1509062522246-3755977927d7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Y2xhc3Nyb29tfGVufDB8fDB8fA%3D%3D&w=1000&q=80"
         />
        <div >
        <h3>We here provide everything you need in order to achieve great heights</h3>
        </div>
        <div >
        <h3>We provide Free Live tests which anyone can take anonymously</h3>
        </div>
        <img src='https://thumbs.dreamstime.com/b/pencil-exam-printed-school-test-testing-exercise-exam-paper-computer-sheet-pencil-school-test-room-165795337.jpg' alt='test' width='50%' >
        </img>
        <img src='https://cdn.abcotvs.com/dip/images/961353_082815-cc-teacher-book-img.jpg?w=1280&r=16%3A9' alt='teacher' 
        />
        <div>
        <h3>We have one of best faculties in town, So why not join us and learn from the best</ h3>
        </div>
        </ div>
    )
}